import React, { Component } from 'react';
import { t } from '../../../../locales';
import moment from 'moment';
import './styles.scss';
import Dropdown from '@axa-asia/emma-stylesheet/lib/components/Dropdown/Dropdown';
import { validateDateOfBirth } from '../../../../utils';
import CountryTelephoneNumber from '@axa-asia/emma-stylesheet/lib/components/CountryTelephoneNumber/CountryTelephoneNumber';
import { PROMOTION_ERROR_CODE } from '../../constants';

export interface OffersFormInfoViewProps {
  offersInfoConfig: any;
  offersData: any;
  prefillData: any;
  updateInfoObjState: (label: any, value: any) => void;
  updatePromotionCode: (promotionErrorCode: string) => void;
  isReview: boolean;
  promotionErrorCode: string;
}

export interface OffersFormInfoViewState {
  // Full name
  nameState: string;
  isShowNameError: boolean;
  isShowNameCorrect: boolean;
  // Gender
  isShowGenderOptionList: boolean;
  genderState: string;
  genderOptionList: Array<any>;
  // Date of Birth
  isShowDateOptionList: boolean;
  date: string;
  dateOptionList: Array<any>;
  isShowMonthOptionList: boolean;
  month: string;
  monthOptionList: Array<any>;
  isShowYearOptionList: boolean;
  year: string;
  yearOptionList: Array<any>;
  errorMsgDOB: string;
  // Email
  emailState: string;
  isShowEmailError: boolean;
  isShowEmailCorrect: boolean;
  // Mobile no.
  mobileOptionList: Array<any>;
  mobileNoIpState: string;
  isShowMobileOptionList: boolean;
  mobileNoState: string;
  isShowMobileError: boolean;
  isShowMobileCorrect: boolean;
  // product
  isShowProductOptionList: boolean;
  productState: string;
  isShowProductError: boolean;
  // promotion code
  isShowPromotionCodeError: boolean;
  isShowPromotionCodeCorrect: boolean;
  promotionCodeState: string;
  // agent code
  isShowAgentCodeError: boolean;
  isShowAgentCodeCorrect: boolean;
  agentCodeState: string;
  // Your financial consultant's mobile (optional)
  consultantMobileNoIpState: string;
  isShowConsultantMobileOptionList: boolean;
  consultantMobileNoState: string;
  isShowConsultantMobileError: boolean;
  isShowConsultantMobileCorrect: boolean;
  mobileMaxLength: number;
  consultantMobileMaxLength: number;
  isShowGenderError: boolean;
}

export class OffersFormInfoView extends Component<
  OffersFormInfoViewProps,
  OffersFormInfoViewState
> {
  constructor(props: any = {}) {
    super(props);
    const inforData =
      props.offersData && props.offersData.infoObj
        ? props.offersData.infoObj
        : {};
    const { name, gender, date, month, year, email, mobileNo } =
      props.prefillData;
    this.state = {
      // Full name
      nameState:
        inforData && inforData.name ? inforData.name : name ? name : '',
      isShowNameError: false,
      isShowNameCorrect: false,
      // Gender
      isShowGenderOptionList: false,
      genderState:
        inforData && inforData.gender ? inforData.gender : gender ? gender : '',
      genderOptionList: [
        {
          optionVal: `${t('GENDER_MALE_OPTION')}`,
          optionTitle: `${t('GENDER_MALE_OPTION')}`,
        },
        {
          optionVal: `${t('GENDER_FEMALE_OPTION')}`,
          optionTitle: `${t('GENDER_FEMALE_OPTION')}`,
        },
      ],
      // Date of Birth
      isShowDateOptionList: false,
      date:
        inforData && inforData.birthday
          ? moment(inforData.birthday).format('DD')
          : date
          ? date
          : '',
      dateOptionList: [
        {
          optionVal: '',
          optionTitle: '',
        },
      ],
      isShowMonthOptionList: false,
      month:
        inforData && inforData.birthday
          ? moment(inforData.birthday).format('MM')
          : month
          ? month
          : '',
      monthOptionList: [
        {
          optionVal: '',
          optionTitle: '',
        },
      ],
      isShowYearOptionList: false,
      year:
        inforData && inforData.birthday
          ? moment(inforData.birthday).format('YYYY')
          : year
          ? year
          : '',
      yearOptionList: [
        {
          optionVal: '',
          optionTitle: '',
        },
      ],
      errorMsgDOB: '',
      // Email
      emailState:
        inforData && inforData.email ? inforData.email : email ? email : '',
      isShowEmailError: false,
      isShowEmailCorrect: false,
      // Mobile no.
      isShowMobileOptionList: false,
      mobileNoIpState:
        inforData && inforData.mobileCountryCode
          ? inforData.mobileCountryCode
          : '852',
      mobileOptionList: [
        {
          optionVal: '852',
          optionTitle: '852',
        },
        {
          optionVal: '853',
          optionTitle: '853',
        },
        {
          optionVal: '86',
          optionTitle: '86',
        },
        {
          optionTitle: '886',
          optionVal: '886',
        },
      ],
      mobileNoState:
        inforData && inforData.mobile
          ? inforData.mobile
          : mobileNo
          ? mobileNo
          : '',
      isShowMobileError: false,
      isShowMobileCorrect: false,
      // product
      isShowProductOptionList: false,
      productState: inforData && inforData.product ? inforData.product : '',
      isShowProductError: false,
      // promotion code
      isShowPromotionCodeError: false,
      isShowPromotionCodeCorrect: false,
      promotionCodeState:
        inforData && inforData.promotionCode ? inforData.promotionCode : '',
      // agent code
      isShowAgentCodeError: false,
      isShowAgentCodeCorrect: false,
      agentCodeState:
        inforData && inforData.agentCode ? inforData.agentCode : '',
      // Your financial consultant's mobile (optional)
      isShowConsultantMobileOptionList: false,
      consultantMobileNoIpState:
        inforData && inforData.consultantMobileCountryCode
          ? inforData.consultantMobileCountryCode
          : '852',
      consultantMobileNoState:
        inforData && inforData.consultantMobile
          ? inforData.consultantMobile
          : '',
      isShowConsultantMobileError: false,
      isShowConsultantMobileCorrect: false,
      mobileMaxLength: 8,
      consultantMobileMaxLength: 8,
      isShowGenderError: false,
    };
    this.onBlurInputName = this.onBlurInputName.bind(this);
    this.setGenderOpenOption = this.setGenderOpenOption.bind(this);
    this.setDateOpenOption = this.setDateOpenOption.bind(this);
    this.setMonthOpenOption = this.setMonthOpenOption.bind(this);
    this.setYearOpenOption = this.setYearOpenOption.bind(this);
    this.onBlurInputEmail = this.onBlurInputEmail.bind(this);
    this.setMobileOpenOption = this.setMobileOpenOption.bind(this);
    this.chooseMobileOption = this.chooseMobileOption.bind(this);
    this.onBlurInputMobile = this.onBlurInputMobile.bind(this);
    this.setConsultantMobileOpenOption =
      this.setConsultantMobileOpenOption.bind(this);
    this.chooseConsultantMobileOption =
      this.chooseConsultantMobileOption.bind(this);
    this.onBlurInputConsultantMobile =
      this.onBlurInputConsultantMobile.bind(this);
    this.onBlurGenderOption = this.onBlurGenderOption.bind(this);
    this.onBlurInputPromotionCode = this.onBlurInputPromotionCode.bind(this);
    this.onBlurInputAgentCode = this.onBlurInputAgentCode.bind(this);
  }

  componentWillReceiveProps(nextProps: OffersFormInfoViewProps) {
    if (
      (nextProps.prefillData.isPOAccount &&
        nextProps.prefillData.isPOAccount !=
          this.props.prefillData.isPOAccount) ||
      (nextProps.offersData &&
        nextProps.offersData.infoObj != this.props.offersData.infoObj)
    ) {
      const inforData =
        nextProps.offersData && nextProps.offersData.infoObj
          ? nextProps.offersData.infoObj
          : {};
      const nextPrefillData = nextProps.prefillData;
      const { name, gender, date, month, year, email, mobileNo } =
        nextPrefillData;
      this.onBlurInputName({
        target: {
          value:
            inforData && inforData.name ? inforData.name : name ? name : '',
        },
      });
      this.chooseGenderOption(
        inforData && inforData.gender ? inforData.gender : gender ? gender : '',
      );
      this.chooseDateOption(
        inforData && inforData.birthday
          ? moment(inforData.birthday).format('DD')
          : date
          ? date
          : '',
      );
      this.chooseMonthOption(
        inforData && inforData.birthday
          ? moment(inforData.birthday).format('MM')
          : month
          ? month
          : '',
      );
      setTimeout(
        () =>
          this.chooseYearOption(
            inforData && inforData.birthday
              ? moment(inforData.birthday).format('YYYY')
              : year
              ? year
              : '',
          ),
        1000,
      );
      this.onBlurInputEmail({
        target: {
          value:
            inforData && inforData.email ? inforData.email : email ? email : '',
        },
      });
      // comment as it will trigger checking on empty mobile field in mobile
      // this.onBlurInputMobile({ target: { value: inforData && inforData.mobile ? inforData.mobile : (mobileNo ? mobileNo : '') } });
    }
  }

  componentDidMount() {
    this.dateCombo();
    this.monthCombo();
    this.yearCombo();

    const { isReview } = this.props;

    const {
      nameState,
      genderState,
      date,
      month,
      year,
      emailState,
      mobileNoState,
      productState,
      promotionCodeState,
    } = this.state;
    // check validation
    (isReview || (!isReview && nameState !== '')) &&
      this.onBlurInputName({ target: { value: nameState } });
    (isReview || (!isReview && genderState !== '')) &&
      this.chooseGenderOption(genderState);
    (isReview || (!isReview && date !== '')) && this.chooseDateOption(date);
    (isReview || (!isReview && month !== '')) && this.chooseMonthOption(month);
    (isReview || (!isReview && year !== '')) &&
      setTimeout(() => this.chooseYearOption(year ? year : ''), 1000);
    (isReview || (!isReview && emailState !== '')) &&
      this.onBlurInputEmail({ target: { value: emailState } });
    (isReview || (!isReview && mobileNoState !== '')) &&
      this.onBlurInputMobile({ value: mobileNoState });
    (isReview || (!isReview && promotionCodeState !== '')) &&
      this.onBlurInputPromotionCode(
        { target: { value: promotionCodeState } },
        true,
      );
  }

  // Full name
  onBlurInputName(e: any) {
    let value = e.target.value;
    value = value.replace(/[^\u4E00-\u9FA5a-zA-Z\s]/g, '');
    if (value) {
      this.setState({
        isShowNameError: false,
        isShowNameCorrect: true,
      });
    } else {
      this.setState({
        isShowNameError: true,
        isShowNameCorrect: false,
      });
    }
    this.setState({ nameState: value }, () => {
      this.props.updateInfoObjState('name', value);
    });
  }

  // Gender
  setGenderOpenOption(val: any) {
    this.setState({
      isShowGenderOptionList: val,
    });
  }

  chooseGenderOption(val: any) {
    this.setState(
      {
        genderState: val,
        isShowGenderError: false,
      },
      () => {
        this.props.updateInfoObjState('gender', val);
      },
    );
  }

  onBlurGenderOption(val: string) {
    val === '' &&
      this.setState({
        isShowGenderError: true,
      });
  }

  // Date of Birth
  dateCombo() {
    const days = [];
    for (let i = 1; i <= 31; i++) {
      let dayString = i.toString();
      if (dayString.length === 1) {
        dayString = `0${dayString}`;
      }
      days.push({
        optionVal: dayString,
        optionTitle: dayString,
      });
    }
    this.setState({
      dateOptionList: days,
    });
  }
  monthCombo() {
    const months = [];
    for (let i = 1; i <= 12; i++) {
      let monthString = i.toString();
      if (monthString.length === 1) {
        monthString = `0${monthString}`;
      }
      months.push({
        optionVal: monthString,
        optionTitle: monthString,
      });
    }
    this.setState({
      monthOptionList: months,
    });
  }
  yearCombo() {
    const years = [];
    const year = new Date().getFullYear();
    for (let i = year - 18; i > year - 82; i--) {
      years.push({
        optionVal: i.toString(),
        optionTitle: i.toString(),
      });
    }
    this.setState({
      yearOptionList: years,
    });
  }

  setDateOpenOption(val: any) {
    this.setState({
      isShowDateOptionList: val,
    });
  }
  chooseDateOption(val: any) {
    const { year, month } = this.state;
    const errorMsgDOB = validateDateOfBirth(year, month, val);
    this.setState(
      {
        date: val,
        errorMsgDOB: errorMsgDOB,
      },
      () => {
        if (!errorMsgDOB) {
          const dob = moment(`${year}${month}${val}`).format('YYYYMMDD');
          this.props.updateInfoObjState('birthday', dob);
        } else {
          this.props.updateInfoObjState('birthday', '');
        }
      },
    );
  }
  setMonthOpenOption(val: any) {
    this.setState({
      isShowMonthOptionList: val,
    });
  }
  chooseMonthOption(val: any) {
    const { year, date } = this.state;
    const errorMsgDOB = validateDateOfBirth(year, val, date);
    this.setState(
      {
        month: val,
        errorMsgDOB: errorMsgDOB,
      },
      () => {
        if (!errorMsgDOB) {
          const dob = moment(`${year}${val}${date}`).format('YYYYMMDD');
          this.props.updateInfoObjState('birthday', dob);
        } else {
          this.props.updateInfoObjState('birthday', '');
        }
      },
    );
  }
  setYearOpenOption(val: any) {
    this.setState({
      isShowYearOptionList: val,
    });
  }
  chooseYearOption(val: any) {
    const { month, date } = this.state;
    const errorMsgDOB = validateDateOfBirth(val, month, date);
    this.setState(
      {
        year: val,
        errorMsgDOB: errorMsgDOB,
      },
      () => {
        if (!errorMsgDOB) {
          const dob = moment(`${val}${month}${date}`).format('YYYYMMDD');
          this.props.updateInfoObjState('birthday', dob);
        } else {
          this.props.updateInfoObjState('birthday', '');
        }
      },
    );
  }

  // Email
  onBlurInputEmail(e: any) {
    const value = e.target.value.trim();
    this.setState({
      emailState: value,
    });
    let updateEmail = value;
    if (!value) {
      updateEmail = '';
      this.setState({
        isShowEmailError: true,
        isShowEmailCorrect: false,
      });
    } else if (!/^[^\s@]+@[^\s@\\.]+\.[^\s@]{2,}$/.test(value)) {
      updateEmail = '';
      this.setState({
        isShowEmailError: true,
        isShowEmailCorrect: false,
      });
    } else {
      this.setState({
        isShowEmailError: false,
        isShowEmailCorrect: true,
      });
    }
    this.props.updateInfoObjState('email', updateEmail);
  }

  // Mobile
  isValidMobileNumber(countryCode: string, mobileNo: string) {
    const mobileLen = mobileNo.length;
    if (RegExp(/[^0-9]/).test(mobileNo)) return false;
    if (countryCode === '86') {
      return mobileLen === 11 && mobileNo.startsWith('1');
    } else if (countryCode === '852' || countryCode === '853') {
      return mobileLen === 8;
    } else if (countryCode === '886') {
      if (mobileNo.substr(0, 1) === '9') {
        return mobileLen === 9;
      }
      if (mobileNo.substr(0, 2) === '09') {
        return mobileLen === 10;
      }
    }
    return false;
  }

  setMobileOpenOption(val: any) {
    this.setState({
      isShowMobileOptionList: val,
    });
  }

  chooseMobileOption(val: any) {
    this.setState(
      {
        mobileNoIpState: val,
        mobileMaxLength: val === '86' ? 11 : 8,
      },
      () => {
        this.onBlurInputMobile({
          value: this.state.mobileNoState,
          countryValue: val,
        });
        this.props.updateInfoObjState('mobileCountryCode', val);
      },
    );
  }
  onBlurInputMobile(e: any, countryCode = '') {
    let { countryValue, value, isError, isCorrect } = e;
    if (
      countryValue &&
      countryValue != this.props.offersData.infoObj.mobileCountryCode
    ) {
      this.chooseMobileOption(countryValue);
      return;
    }
    value = value
      ? value.trim()
      : value === undefined
      ? this.state.mobileNoState
      : '';
    const countryCodeState = countryValue
      ? countryValue
      : this.state.mobileNoIpState;
    const mobileValue =
      countryCodeState && countryCodeState === '86'
        ? value.substring(0, 11)
        : countryCodeState === '886'
        ? value.substring(0, 10)
        : value.substring(0, 8);
    this.setState({
      mobileNoState: mobileValue,
    });
    let updateMobileNo = mobileValue;
    if (
      value &&
      (countryCode
        ? true
        : this.isValidMobileNumber(
            countryValue ? countryValue : this.state.mobileNoIpState,
            mobileValue,
          ))
    ) {
      this.setState({
        isShowMobileError: false,
        isShowMobileCorrect: true,
      });
    } else {
      updateMobileNo = '';
      this.setState({
        isShowMobileError: true,
        isShowMobileCorrect: false,
      });
    }
    this.props.updateInfoObjState('mobile', updateMobileNo);
  }

  // Your financial consultant's mobile (optional)
  setConsultantMobileOpenOption(val: any) {
    this.setState({
      isShowConsultantMobileOptionList: val,
    });
  }

  chooseConsultantMobileOption(val: any) {
    this.setState(
      {
        consultantMobileNoIpState: val,
        consultantMobileMaxLength: val === '86' ? 11 : 8,
      },
      () => {
        this.onBlurInputConsultantMobile({
          value: this.state.consultantMobileNoState,
          countryValue: val,
        });
        this.props.updateInfoObjState('consultantMobileCountryCode', val);
      },
    );
  }
  onBlurInputConsultantMobile(e: any, countryCode = '') {
    let { countryValue, value, isError, isCorrect } = e;
    if (
      countryValue &&
      countryValue != this.props.offersData.infoObj.consultantMobileCountryCode
    ) {
      this.chooseConsultantMobileOption(countryValue);
      return;
    }
    const orginalValue = value;
    value = value
      ? value.trim()
      : value === undefined
      ? this.state.consultantMobileNoState
      : '';
    if (
      orginalValue &&
      this.state.consultantMobileNoState &&
      orginalValue.length === 0 &&
      this.state.consultantMobileNoState.length === 1
    ) {
      value = '';
    } else if (
      !orginalValue &&
      this.state.consultantMobileNoState.length === 1
    ) {
      value = '';
    }
    const countryCodeState = countryValue
      ? countryValue
      : this.state.consultantMobileNoIpState;
    const mobileValue =
      countryCodeState && countryCodeState === '86'
        ? value.substring(0, 11)
        : countryCodeState === '886'
        ? value.substring(0, 10)
        : value.substring(0, 8);
    this.setState(
      {
        consultantMobileNoState: mobileValue,
      },
      () => {
        this.props.updateInfoObjState('consultantMobile', mobileValue);
      },
    );
    if (!value) {
      this.setState({
        isShowConsultantMobileError: false,
        isShowConsultantMobileCorrect: false,
      });
    } else if (
      value &&
      (countryCode
        ? true
        : this.isValidMobileNumber(
            countryValue ? countryValue : this.state.consultantMobileNoIpState,
            mobileValue,
          ))
    ) {
      this.setState({
        isShowConsultantMobileError: false,
        isShowConsultantMobileCorrect: true,
      });
    } else {
      this.setState({
        isShowConsultantMobileError: true,
        isShowConsultantMobileCorrect: false,
      });
    }
  }

  // promotion code
  onBlurInputPromotionCode(e: any, isReViewCheck?: boolean) {
    const { updatePromotionCode, updateInfoObjState, offersInfoConfig } =
      this.props;
    const { isSportsPaOfferPromo } =
      offersInfoConfig && offersInfoConfig.promotionCode;
    const value = e.target.value.trim();
    this.setState({
      promotionCodeState: value,
    });
    const isHasPromoCodeCheck = isSportsPaOfferPromo && value.length !== 6;
    const isNonePromoCodeCheck =
      !isSportsPaOfferPromo && !(value.length === 6 || value.length === 0);
    if (!isReViewCheck) {
      if (isHasPromoCodeCheck) {
        updatePromotionCode(PROMOTION_ERROR_CODE[0]);
      } else if (isNonePromoCodeCheck) {
        updatePromotionCode(PROMOTION_ERROR_CODE[1]);
      } else {
        updatePromotionCode('');
      }
    }
    setTimeout(() => {
      const { promotionErrorCode } = this.props;
      if (promotionErrorCode) {
        this.setState({
          isShowPromotionCodeError: true,
          isShowPromotionCodeCorrect: false,
        });
      } else {
        this.setState({
          isShowPromotionCodeError: false,
          isShowPromotionCodeCorrect: true,
        });
      }
      updateInfoObjState('promotionCode', value);
    });
  }

  // agent code
  onBlurInputAgentCode(e: any) {
    const value = e.target.value;
    if (value === '') {
      this.setState({
        isShowAgentCodeError: false,
        isShowAgentCodeCorrect: false,
      });
    } else if (value.length === 6) {
      this.setState({
        isShowAgentCodeError: false,
        isShowAgentCodeCorrect: true,
      });
    } else {
      this.setState({
        isShowAgentCodeError: true,
        isShowAgentCodeCorrect: false,
      });
    }
    this.setState({ agentCodeState: value }, () => {
      this.props.updateInfoObjState('agentCode', value);
    });
  }

  render() {
    const {
      name,
      gender,
      birthday,
      email,
      mobile,
      consultantMobile,
      product,
      promotionCode,
      agentCode,
    } = this.props.offersInfoConfig;
    const {
      nameState,
      isShowNameError,
      isShowNameCorrect,
      isShowGenderOptionList,
      genderOptionList,
      genderState,
      dateOptionList,
      monthOptionList,
      yearOptionList,
      date,
      isShowDateOptionList,
      month,
      isShowMonthOptionList,
      year,
      isShowYearOptionList,
      errorMsgDOB,
      emailState,
      isShowEmailError,
      isShowEmailCorrect,
      isShowMobileError,
      isShowMobileCorrect,
      mobileNoIpState,
      mobileOptionList,
      isShowMobileOptionList,
      mobileNoState,
      consultantMobileNoState,
      consultantMobileNoIpState,
      isShowConsultantMobileOptionList,
      isShowConsultantMobileError,
      isShowConsultantMobileCorrect,
      mobileMaxLength,
      consultantMobileMaxLength,
      isShowGenderError,
      productState,
      isShowProductOptionList,
      isShowProductError,
      isShowPromotionCodeError,
      isShowPromotionCodeCorrect,
      promotionCodeState,
      isShowAgentCodeError,
      isShowAgentCodeCorrect,
      agentCodeState,
    } = this.state;
    const { promotionErrorCode } = this.props;
    const isSportsPaOfferPromo =
      promotionCode && promotionCode.isSportsPaOfferPromo;
    return (
      <div className="offers-form-information-container row">
        <div className="col-12">
          {/* Full name */}
          <div>
            <div className="row">
              <div className="emma-stylesheet-label col-12">
                <label
                  className="emma-stylesheet-label__text"
                  htmlFor={name.label}
                >
                  {name.label}
                  <span className="offers-form-information__red-star">*</span>
                </label>
              </div>
            </div>
            <div className="row">
              <div
                className={`emma-stylesheet-input col-12 ${
                  isShowNameError && name.errorMessage
                    ? 'emma-stylesheet-input-error'
                    : isShowNameCorrect
                    ? 'emma-stylesheet-input-success'
                    : ''
                }`}
              >
                <input
                  className={`emma-stylesheet-input-field col-12 ${
                    isShowNameError && name.errorMessage
                      ? 'emma-stylesheet-input-error-field'
                      : 'emma-stylesheet-input-success-field'
                  }`}
                  value={nameState}
                  id={name.label}
                  placeholder={t('NAME_PLACEHOLDER')}
                  type="text"
                  maxLength={100}
                  onChange={this.onBlurInputName}
                  onBlur={this.onBlurInputName}
                />
              </div>
            </div>
            {isShowNameError && name.errorMessage && (
              <div className="row">
                <div className="emma-stylesheet-input-tip-error col-12">
                  {name.errorMessage}
                </div>
              </div>
            )}
          </div>
          {/* Gender */}
          <div className="mg-top24">
            <div className="row">
              <div className="emma-stylesheet-label col-12">
                <label
                  className="emma-stylesheet-label__text"
                  htmlFor={gender.label}
                >
                  {gender.label}
                  <span className="offers-form-information__red-star">*</span>
                </label>
              </div>
            </div>
            <div className="row">
              <Dropdown
                title={t('GENDER_PLACEHOLDER')}
                dropDownClassName="col-12"
                optionList={genderOptionList}
                isShowOptionList={isShowGenderOptionList}
                setOption={this.setGenderOpenOption}
                value={genderState}
                onClickAction={(val: any) => {
                  this.chooseGenderOption(val);
                }}
                onBlurOptions={this.onBlurGenderOption}
              />
            </div>
            {isShowGenderError && (
              <div className="row">
                <div className="emma-stylesheet-input-tip-error col-12">
                  {gender.errorMessage}
                </div>
              </div>
            )}
          </div>
          {/* Date of Birth */}
          <div className="mg-top24">
            <div className="row">
              <div className="emma-stylesheet-label col-12">
                <label
                  className="emma-stylesheet-label__text"
                  htmlFor={birthday.label}
                >
                  {birthday.label}
                  <span className="offers-form-information__red-star">*</span>
                </label>
              </div>
            </div>
            <div className="offers-form-information__birthdate-container row">
              <Dropdown
                title={'YYYY'}
                dropDownClassName="offers-form-information__birthdate"
                optionList={yearOptionList}
                isShowOptionList={isShowYearOptionList}
                setOption={this.setYearOpenOption}
                value={year}
                onClickAction={(val: any) => {
                  this.chooseYearOption(val);
                }}
              />
              <div className="offers-form-information__birthdate-split">/</div>
              <Dropdown
                title={'MM'}
                dropDownClassName="offers-form-information__birthdate"
                optionList={monthOptionList}
                isShowOptionList={isShowMonthOptionList}
                setOption={this.setMonthOpenOption}
                value={month}
                onClickAction={(val: any) => {
                  this.chooseMonthOption(val);
                }}
              />
              <div className="offers-form-information__birthdate-split">/</div>
              <Dropdown
                title={'DD'}
                dropDownClassName="offers-form-information__birthdate"
                optionList={dateOptionList}
                isShowOptionList={isShowDateOptionList}
                setOption={this.setDateOpenOption}
                value={date}
                onClickAction={(val: any) => {
                  this.chooseDateOption(val);
                }}
              />
            </div>
            {errorMsgDOB && (
              <div className="row">
                <div className="emma-stylesheet-input-tip-error col-12">
                  {t(errorMsgDOB)}
                </div>
              </div>
            )}
          </div>
          {/* Email */}
          <div className="mg-top24">
            <div className="row">
              <div className="emma-stylesheet-label col-12">
                <label
                  className="emma-stylesheet-label__text"
                  htmlFor={email.label}
                >
                  {email.label}
                  <span className="offers-form-information__red-star">*</span>
                </label>
              </div>
            </div>
            <div className="row">
              <div
                className={`emma-stylesheet-input col-12 ${
                  isShowEmailError && email.errorMessage
                    ? 'emma-stylesheet-input-error'
                    : isShowEmailCorrect
                    ? 'emma-stylesheet-input-success'
                    : ''
                }`}
              >
                <input
                  className={`emma-stylesheet-input-field col-12 ${
                    isShowEmailError && email.errorMessage
                      ? 'emma-stylesheet-input-error-field'
                      : isShowEmailCorrect
                      ? 'emma-stylesheet-input-success-field'
                      : ''
                  }`}
                  defaultValue={emailState}
                  id={email.label}
                  placeholder={t('EMAIL_PLACEHOLDER')}
                  type="text"
                  onChange={this.onBlurInputEmail}
                  onBlur={this.onBlurInputEmail}
                />
              </div>
            </div>
            {isShowEmailError && email.errorMessage && (
              <div className="row">
                <div className="emma-stylesheet-input-tip-error col-12">
                  {email.errorMessage}
                </div>
              </div>
            )}
          </div>
          {/* Mobile no */}
          <div className="mg-top24">
            <div className="row">
              <div className="emma-stylesheet-label col-12">
                <label
                  className="emma-stylesheet-label__text"
                  htmlFor={mobile.label}
                >
                  {mobile.label}
                  <span className="offers-form-information__red-star">*</span>
                </label>
              </div>
            </div>
            <div className="offers-form-information__mobile row">
              <CountryTelephoneNumber
                {...{
                  onChange: this.onBlurInputMobile,
                  onBlur: this.onBlurInputMobile,
                  onFocus: this.onBlurInputMobile,
                  dropdownPlaceholder: t(
                    'COUNTRY_TELEPHONE_NUMBER_DROPDOWN_PLACEHOLDER',
                  ),
                  placeholder: t('MOBILE_PLACEHOLDER'),
                  countryOption: mobileOptionList,
                  errorMessage: '',
                  mobileValue: mobileNoState,
                  countryCode: mobileNoIpState,
                  mandatory: true,
                }}
              />
            </div>
            {isShowMobileError && mobile.errorMessage && (
              <div className="row">
                <div className="emma-stylesheet-input-tip-error col-12">
                  {mobile.errorMessage}
                </div>
              </div>
            )}
          </div>
          {/* Interested Product */}
          <div className="mg-top24">
            <div className="row">
              <div className="emma-stylesheet-label col-12">
                <label
                  className="emma-stylesheet-label__text"
                  htmlFor={product.label}
                >
                  {product.label}
                  <span className="offers-form-information__red-star">*</span>
                </label>
              </div>
            </div>
            <div className="offers-form-information__mobile row">
              <Dropdown
                isEnableGa={true}
                dropDownClassName="col-12"
                title={product.placeholder}
                optionList={product.options}
                isShowOptionList={isShowProductOptionList}
                setOption={(val: any) => {
                  this.setState({
                    isShowProductOptionList: val,
                  });
                }}
                value={productState}
                onClickAction={(val: any) => {
                  this.setState(
                    {
                      productState: val,
                      isShowProductError: false,
                    },
                    () => {
                      this.props.updateInfoObjState('product', val);
                    },
                  );
                }}
                onBlurOptions={(val: any) => {
                  val === '' &&
                    this.setState({
                      isShowProductError: true,
                    });
                }}
              />
            </div>
            {isShowProductError && product.errorMessage && (
              <div className="row">
                <div className="emma-stylesheet-input-tip-error col-12">
                  {product.errorMessage}
                </div>
              </div>
            )}
          </div>
          {/* promotion code */}
          <div className="mg-top24">
            <div className="row">
              <div className="emma-stylesheet-label col-12">
                <label
                  className="emma-stylesheet-label__text"
                  htmlFor={promotionCode.label}
                >
                  {isSportsPaOfferPromo ? (
                    <span>
                      {promotionCode.mandatoryLabel}
                      <span className="offers-form-information__red-star">
                        *
                      </span>
                    </span>
                  ) : (
                    <span>{promotionCode.label}</span>
                  )}
                </label>
              </div>
            </div>
            <div className="row">
              <div
                className={`emma-stylesheet-input col-12 ${
                  isShowPromotionCodeError
                    ? 'emma-stylesheet-input-error'
                    : isShowPromotionCodeCorrect && isSportsPaOfferPromo
                    ? 'emma-stylesheet-input-success'
                    : ''
                }`}
              >
                <input
                  className={`emma-stylesheet-input-field col-12 ${
                    isShowPromotionCodeError && promotionErrorCode
                      ? 'emma-stylesheet-input-error-field'
                      : isShowPromotionCodeCorrect
                      ? 'emma-stylesheet-input-success-field'
                      : ''
                  }`}
                  defaultValue={promotionCodeState}
                  id={promotionCode.label}
                  type="text"
                  onChange={(e: any) => this.onBlurInputPromotionCode(e)}
                  onBlur={(e: any) => this.onBlurInputPromotionCode(e)}
                />
              </div>
            </div>
            {isShowPromotionCodeError && promotionErrorCode && (
              <div className="row">
                <div className="emma-stylesheet-input-tip-error col-12">
                  {t(`${promotionErrorCode.replace(':', '_')}`)}
                </div>
              </div>
            )}
          </div>

          {/* agent code */}
          <div className="mg-top24">
            <div className="row">
              <div className="emma-stylesheet-label col-12">
                <label className="emma-stylesheet-label__text">
                  <span>{agentCode.label}</span>
                </label>
              </div>
            </div>
            <div className="row">
              <div
                className={`emma-stylesheet-input col-12 ${
                  isShowAgentCodeError
                    ? 'emma-stylesheet-input-error'
                    : isShowAgentCodeCorrect
                    ? 'emma-stylesheet-input-success'
                    : ''
                }`}
              >
                <input
                  className={`emma-stylesheet-input-field col-12 ${
                    isShowAgentCodeError
                      ? 'emma-stylesheet-input-error-field'
                      : isShowAgentCodeCorrect
                      ? 'emma-stylesheet-input-success-field'
                      : ''
                  }`}
                  defaultValue={agentCodeState}
                  id={agentCode.label}
                  type="text"
                  onChange={(e: any) => this.onBlurInputAgentCode(e)}
                  onBlur={(e: any) => this.onBlurInputAgentCode(e)}
                />
              </div>
            </div>
            {isShowAgentCodeError && agentCode.errorMessage && (
              <div className="row">
                <div className="emma-stylesheet-input-tip-error col-12">
                  {agentCode.errorMessage}
                </div>
              </div>
            )}
          </div>

          {/* <div className="mg-top24">
            <div className="row">
              <div className="emma-stylesheet-label col-12">
                <label className="emma-stylesheet-label__text" htmlFor={consultantMobile.label}>{consultantMobile.label}</label>
              </div>
            </div>
            <div className="offers-form-information__mobile row">
              <CountryTelephoneNumber {
                ...
                {
                  onChange: this.onBlurInputConsultantMobile,
                  onBlur: this.onBlurInputConsultantMobile,
                  onFocus: this.onBlurInputConsultantMobile,
                  placeholder: t("MOBILE_PLACEHOLDER"),
                  countryOption: mobileOptionList,
                  errorMessage: '',
                  mobileValue: consultantMobileNoState,
                  countryCode: consultantMobileNoIpState,
                  mandatory: false
                }
              } />
            </div>
            {isShowConsultantMobileError && consultantMobile.errorMessage &&
              <div className="row">
                <div className="emma-stylesheet-input-tip-error col-12">
                  {consultantMobile.errorMessage}
                </div>
              </div>
            }
          </div> */}
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    return {};
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}
